import { render, staticRenderFns } from "./sendPaymentReceivedDialog.vue?vue&type=template&id=19ac725e&"
import script from "./sendPaymentReceivedDialog.vue?vue&type=script&lang=js&"
export * from "./sendPaymentReceivedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports